export const inputStyles = {
    width: '25%',
    height: 30,
    borderRadius: 5,
    outline: 'none',
    backgroundColor: 'rgb(233, 233, 233)',
    border: '1px solid gray',
    paddingLeft: 20
}

export const buttonStyles = {
    width: '10%',
    height: 30,
    borderRadius: 5,
    backgroundColor: 'rgb(33, 33, 33)',
    border: 'none',
    cursor: 'pointer',
    marginLeft: 5,
    color: '#fff'
}